"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomButton = exports.Subtitle = exports.Title = exports.IconWrapper = exports.ContentWrapper = exports.Overlay = void 0;
const button_1 = require("@pulse-web-ui/button");
const theme_1 = require("@pulse-web-ui/theme");
exports.Overlay = theme_1.styled.div `
  width: 100%;
  height: 640px;
  background: ${({ theme }) => theme.colors.surface.background};
  display: flex;
  flex-direction: column;
  align-items: center;

  ${theme_1.media.desktop} {
    height: 680px;
  }
`;
exports.ContentWrapper = theme_1.styled.div `
  margin-top: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({ theme }) => theme.colors.surface.primary};
  padding: 24px;
  outline: none;
  border-radius: calc(${({ theme }) => theme.common.radius} * 6);
  box-sizing: border-box;
  position: relative;

  ${theme_1.media.desktop} {
    width: 536px;
  }
`;
exports.IconWrapper = theme_1.styled.div `
  max-width: 80px;
`;
exports.Title = theme_1.styled.div `
  ${theme_1.typography.medium20}
  text-align: center;
  white-space: break-spaces;
  margin-top: 16px;

  ${theme_1.media.desktop} {
    ${theme_1.typography.medium24}
  }
`;
exports.Subtitle = theme_1.styled.div `
  ${theme_1.typography.regular16}
  color: ${({ theme }) => theme.colors.text.secondary};
  text-align: center;
  white-space: break-spaces;
  margin-top: 8px;
  line-height: 24px;

  ${theme_1.media.desktop} {
    ${theme_1.typography.regular18}
    line-height: 26px;
  }
`;
exports.CustomButton = (0, theme_1.styled)(button_1.Button) `
  ${theme_1.typography.medium18}
  line-height: 26px;
  margin-top: 24px;
  box-sizing: border-box;
  width: 100%;

  ${theme_1.media.desktop} {
    width: auto;
  }
`;
